import { Article, Download, Medication } from "@mui/icons-material";
import {
  Button,
  DialogTitle,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { CommonDialog } from "../../../components/common/CommonDialog";
import ControlMedication from "../../../components/common/ControlMedication";
import { GetBinary } from "../../../services/fhir/patientsummary/Binary/GetBinary";
import { IframeDialog } from "../../ehrrecords/components/IframeDialog";

interface MedicalPrescriptionActionsProps {
  row: any;
  cardActions?: boolean;
}

export default function MedicalPrescriptionActions({
  row,
  cardActions,
}: MedicalPrescriptionActionsProps) {
  const [base64, setBase64] = useState<any>();
  const [openDocument, setOpenDocument] = useState<boolean>(false);
  const [openMedicalControl, setOpenMedicationControl] =
    useState<boolean>(false);

  async function getDocumentPdf() {
    const response = await GetBinary({ urlBinary: row?.binaryUrl });
    setBase64(response);
    return response;
  }

  async function downloadBase64File() {
    const auxDocument = !base64 ? await getDocumentPdf() : base64;
    const linkSource = `data:${auxDocument?.contentType};base64,${auxDocument?.data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = "Receita médica";
    downloadLink.click();
  }

  const dialogs = (
    <>
      {openDocument && (
        <IframeDialog
          handleClose={() => setOpenDocument(false)}
          isOpen={openDocument}
          data={row?.binaryUrl}
          title={row?.description}
          loadedBase64={base64}
          setLoaded={setBase64}
        />
      )}
      {openMedicalControl && (
        <CommonDialog
          isOpen={openMedicalControl}
          handleClose={() => setOpenMedicationControl(false)}
        >
          <DialogTitle>Controle o uso do seu remédio</DialogTitle>
          <Stack paddingX={1} pb={2}>
            {row?.medication?.map((el: any, index: number) => (
              <ControlMedication key={index} data={el} index={index} />
            ))}
          </Stack>
        </CommonDialog>
      )}
    </>
  );

  if (cardActions) {
    return (
      <>
        <Stack direction="row" spacing={1} width="100%">
          <Button
            variant="outlined"
            color="primary"
            size="small"
            fullWidth
            startIcon={<Article sx={{ fontSize: 18 }} />}
            onClick={() => setOpenDocument(true)}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.8125rem",
              py: 0.75,
            }}
          >
            Visualizar
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            startIcon={<Download sx={{ fontSize: 18 }} />}
            onClick={() => downloadBase64File()}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.8125rem",
              py: 0.75,
            }}
          >
            Baixar
          </Button>
        </Stack>
        {row?.medication?.length > 0 && (
          <Button
            variant="text"
            color="primary"
            size="small"
            fullWidth
            startIcon={<Medication sx={{ fontSize: 18 }} />}
            onClick={() => setOpenMedicationControl(true)}
            sx={{
              mt: 0.75,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.8rem",
            }}
          >
            Controle de medicamento
          </Button>
        )}
        {dialogs}
      </>
    );
  }

  return (
    <Stack width="fit-content">
      <Stack direction="row" spacing={0.5}>
        <IconButton size="small" onClick={() => setOpenDocument(true)}>
          <Tooltip title="Visualizar documento">
            <Article fontSize="small" />
          </Tooltip>
        </IconButton>
        <IconButton size="small" onClick={() => downloadBase64File()}>
          <Tooltip title="Baixar">
            <Download fontSize="small" />
          </Tooltip>
        </IconButton>
        <IconButton
          size="small"
          onClick={() => setOpenMedicationControl(true)}
        >
          <Tooltip title="Uso do medicamento">
            <Medication fontSize="small" />
          </Tooltip>
        </IconButton>
      </Stack>
      {dialogs}
    </Stack>
  );
}
